export default __webpack_public_path__ + "static/media/covid-header.729429ea.svg";